import React from 'react';
import PressableDynamicOpacity from './PressableDynamicOpacity';
import ScaledImage, { ScaledImageProps } from './ScaledImage';
import { useAvatar } from '../../hooks/useAvatar';
import Text, { TextProps } from './Text';
import { Paper } from './Paper';
import { View } from 'react-native';
import Stack from './Stack';

export type LargeDescriptiveImageOwnProps = {
    imageUrl: string;
    description?: string;
    onPress?: () => void;
    labelProps?: Partial<TextProps>;
    testId?: string;
    pressableTestId?: string;
} & Omit<ScaledImageProps, 'uri' | 'alt' | 'containerStyle' | 'restrict'>;

export type LargeDescriptiveImageProps = LargeDescriptiveImageOwnProps;

const LargeDescriptiveImage: React.FC<LargeDescriptiveImageProps> = (props) => {
    const { isLoadingAvatar, avatar } = useAvatar({
        avatarAPIUrl: props.imageUrl,
    });

    // If not loading and no avatar, don't render anything
    if (!isLoadingAvatar && !avatar) return null;

    const content = (
        <Paper style={{ width: '100%', overflow: 'hidden' }} testID={props.testID}>
            <View style={{ width: '100%', overflow: 'hidden' }}>
                <ScaledImage
                    // Passing in null here will render a skeleton
                    uri={isLoadingAvatar ? null : (avatar?.base64 as string)}
                    containerStyle={{
                        width: '100%',
                    }}
                    alt={props.description || ''}
                    restrict="width"
                />
            </View>
            {props.description ? (
                <Stack horizontal fullWidth justify="center">
                    <Text variant="card-support">{props.description}</Text>
                </Stack>
            ) : null}
        </Paper>
    );

    if (props.onPress) {
        return (
            <PressableDynamicOpacity
                style={{ width: '100%' }}
                onPress={props.onPress}
                testID={!!props.onPress ? props.pressableTestId : undefined}
            >
                {content}
            </PressableDynamicOpacity>
        );
    } else {
        return content;
    }
};

export default React.memo(LargeDescriptiveImage);
